import React, { useState } from "react";
import { Alert, Button, Chip, Stack, Typography } from "@mui/joy";
import { useLocation } from "react-router-dom";
import { useGetSlackAuthorizationUrl } from "../../services/api";

interface SlackInstallButtonProps {
  organizationIntegrationId?: string | null;
  installationStatus?: string | null;
}

const SlackInstallButton: React.FC<SlackInstallButtonProps> = ({
  organizationIntegrationId,
  installationStatus,
}) => {
  const location = useLocation();
  const getSlackAuthorizationUrl = useGetSlackAuthorizationUrl();
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  if (installationStatus === "installed") {
    return (
      <Chip size="sm" color="success" variant="soft">
        Slack app installed
      </Chip>
    );
  }

  const handleConnect = async () => {
    if (!organizationIntegrationId) return;

    setLoading(true);
    setError(null);
    try {
      const response = await getSlackAuthorizationUrl(
        organizationIntegrationId,
        `${location.pathname}${location.search}`,
      );
      window.location.assign(response.authorization_url);
    } catch (err: any) {
      setError(err?.message || "Failed to start Slack app installation.");
      setLoading(false);
    }
  };

  return (
    <Stack spacing={0.75} alignItems="flex-end">
      <Typography level="body-xs" color="neutral">
        Organization app installation
      </Typography>
      <Button
        size="sm"
        variant="soft"
        onClick={handleConnect}
        loading={loading}
        disabled={!organizationIntegrationId}
      >
        Install Slack app
      </Button>
      {error && (
        <Alert color="danger" variant="soft">
          {error}
        </Alert>
      )}
    </Stack>
  );
};

export default SlackInstallButton;
